import { Component, type ReactNode } from 'react';

/** Minimal error boundary — keeps one broken subtree from blanking the page. */
export class ErrorBoundary extends Component<
  { children: ReactNode; fallback?: (msg: string) => ReactNode },
  { error: Error | null }
> {
  state = { error: null as Error | null };
  static getDerivedStateFromError(error: Error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      const msg = this.state.error.message;
      return this.props.fallback ? this.props.fallback(msg) : <p className="error">Component error: {msg}</p>;
    }
    return this.props.children;
  }
}
